/**
 * Lumis Experience (lum_track) for home carousels:
 * - Principal: .dsa-home-banner (home-banner.js + ads-principal.js)
 * - Publicidade: .dsa-section-banner-secundario (banner-publicidade.js + ads-publicidade.js)
 *
 * Impressions: after each completed slide transition (and once on load). Clicks: link slides only
 * (no iframe/video). Banner names are URI-encoded in HTML; we decode before sending.
 *
 * Depends on `analytics/lum-experience-utils.js` (window.AllosLumExperience), loaded first.
 */
(function (window, document) {
  'use strict';

  var api = window.AllosLumExperience;
  if (!api) {
    return;
  }

  var EVENT_IDS = {
    PRINCIPAL_IMPRESSION: 'allos_home_banner_principal_impression',
    PRINCIPAL_CLICK: 'allos_home_banner_principal_click',
    PUBLICIDADE_IMPRESSION: 'allos_banner_publicidade_impression',
    PUBLICIDADE_CLICK: 'allos_banner_publicidade_click',
  };

  /**
   * One entry per carousel: roots for Swiper polling, link selector for click capture,
   * and matching Experience event ids.
   */
  var BANNER_CAROUSELS = [
    {
      swiperRoot: '.dsa-home-banner.swiper',
      slideLinkSelector: '.dsa-home-banner a.swiper-slide',
      impressionEventId: EVENT_IDS.PRINCIPAL_IMPRESSION,
      clickEventId: EVENT_IDS.PRINCIPAL_CLICK,
    },
    {
      swiperRoot: '.dsa-section-banner-secundario.swiper',
      slideLinkSelector: '.dsa-section-banner-secundario a.swiper-slide',
      impressionEventId: EVENT_IDS.PUBLICIDADE_IMPRESSION,
      clickEventId: EVENT_IDS.PUBLICIDADE_CLICK,
    },
  ];

  var SWIPER_WAIT_MS = 8000;
  var SWIPER_POLL_MS = 100;
  /** Ignore a second identical impression fired within this window (e.g. double callback). */
  var IMPRESSION_DEDUP_MS = 100;

  function decodeBannerNameFromAttr(raw) {
    return api.decodeURIComponentAttr(raw);
  }

  /** Builds monitor payload from a slide node; null if missing data-allos-banner-name. */
  function lumPayloadFromSlide(slide) {
    if (!slide) {
      return null;
    }
    var raw = slide.getAttribute('data-allos-banner-name');
    var name = decodeBannerNameFromAttr(raw);
    if (name === null || name === '') {
      return null;
    }
    return {
      // eslint-disable-next-line camelcase -- monitor field id
      banner_name: name,
    };
  }

  /** If the slide has a banner payload, send eventId to lum_track (when ready). */
  function emitMonitorEventForSlide(eventId, slideEl) {
    var data = lumPayloadFromSlide(slideEl);
    if (data) {
      api.emitWhenReady(eventId, data);
    }
  }

  /**
   * DOM node that Swiper is showing. Prefer slides[activeIndex] (works with loop + duplicates);
   * realIndex-only lookups break on last-to-first wrap.
   */
  function getVisibleSlideElement(carouselRoot, swiper) {
    var slides = swiper.slides;
    var i = swiper.activeIndex;
    if (slides && typeof i === 'number' && !window.isNaN(i) && i >= 0) {
      var slide = slides[i];
      if (slide && slide.classList && slide.classList.contains('swiper-slide')) {
        return slide;
      }
    }
    return carouselRoot.querySelector('.swiper-wrapper .swiper-slide-active');
  }

  /**
   * Returns false if this is a duplicate of the previous emission within IMPRESSION_DEDUP_MS
   * (same logical slide + same name). Mutates state when returning true.
   */
  function shouldSendImpression(state, realIndex, bannerName, now) {
    var key = realIndex + '\u0000' + bannerName;
    if (key === state.key && now - state.at < IMPRESSION_DEDUP_MS) {
      return false;
    }
    state.key = key;
    state.at = now;
    return true;
  }

  /**
   * Swiper is created by a separate deferred script; poll until el.swiper exists, then subscribe.
   */
  function whenSwiperReady(rootSelector, onReady) {
    api.pollUntil(
      function () {
        var root = document.querySelector(rootSelector);
        return root && root.swiper ? { root: root, swiper: root.swiper } : null;
      },
      function (pair) {
        onReady(pair.root, pair.swiper);
      },
      SWIPER_POLL_MS,
      SWIPER_WAIT_MS
    );
  }

  function bindCarouselImpressions(carousel) {
    whenSwiperReady(carousel.swiperRoot, function (carouselRoot, swiper) {
      var dedup = { key: '', at: 0 };

      var recordImpressionAfterTransition = function () {
        window.requestAnimationFrame(function () {
          var slide = getVisibleSlideElement(carouselRoot, swiper);
          var data = lumPayloadFromSlide(slide);
          if (!data) {
            return;
          }
          var now = Date.now();
          if (!shouldSendImpression(dedup, swiper.realIndex, data.banner_name, now)) {
            return;
          }
          api.emitWhenReady(carousel.impressionEventId, data);
        });
      };

      swiper.on('slideChangeTransitionEnd', recordImpressionAfterTransition);
      recordImpressionAfterTransition();
    });
  }

  /**
   * Delegated click: walk carousels in order; first matching slide link wins (regions do not overlap).
   */
  function onBannerCarouselClickCapture(event) {
    var target = event.target;
    if (!target || !target.closest) {
      return;
    }
    for (var i = 0; i < BANNER_CAROUSELS.length; i++) {
      var carousel = BANNER_CAROUSELS[i];
      var slide = target.closest(carousel.slideLinkSelector);
      if (!slide) {
        continue;
      }
      emitMonitorEventForSlide(carousel.clickEventId, slide);
      return;
    }
  }

  function init() {
    for (var i = 0; i < BANNER_CAROUSELS.length; i++) {
      bindCarouselImpressions(BANNER_CAROUSELS[i]);
    }
    document.addEventListener('click', onBannerCarouselClickCapture, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(window, document);
